import axios from "axios";
import { isBrowser } from "../util/env-utils";

export interface Suggestion {
  title: string;
  slug: string;
}

export interface SearchHit {
  title: string;
  slug: string;
  description: string;
  tags: string[];
  platforms: string[];
  groups: string[];
  category: string;
  departmentSlug: string;
  departmentSection: string;
  serviceGroup: string;
}

export interface SearchRequestModel {
  groups?: string[];
  tags?: string[];
  platforms?: string[];
  slugs?: string[];
  category?: string | string[];
  departmentSlug?: string | string[];
  departmentSection?: string;
  serviceGroup?: string;
  query?: string;
  targets?: string[];
  highlighted?: boolean;
  top_hit?: number;
  from?: number;
  size?: number;
  isDigital?: boolean;
  isOnline?: boolean;
  hasLink?: boolean;
}

const getBackendEndpoint = () => {
  return (
    (isBrowser ? (window as any).BACKEND_ENDPOINT : undefined) ||
    process.env.BACKEND_ENDPOINT
  );
};

const apiBaseUrl = `${getBackendEndpoint()}/v1`;

const axiosInstance = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

export async function searchSuggestionsByTitle(
  value: string,
  limit: number
): Promise<Suggestion[]> {
  const response = await axiosInstance.get<Suggestion[]>(
    `/search/suggestions-by-title`,
    {
      params: {
        q: value,
        limit,
      },
    }
  );

  return response.data;
}

export async function searchCatalog(
  request: SearchRequestModel
): Promise<SearchHit[]> {
  const response = await axiosInstance.post<SearchHit[]>(`/search`, request);
  return response.data;
}
